import React, { Component } from 'react';

export default class Head extends Component {
	render() {
		let gifUrl = require('./img/android.gif') + "?a=" + Math.random();
		
		return <div style={{}}>
			
			<img src={gifUrl} style={{
				position:"absolute",
				left: (360 - 176)/2,
				top: 30,
				width:176,
				height: 176,
			}} /> 
			<div style={{
				position:"absolute",
				left: (360 - 176)/2,
				top: 30,
				width:168,
				height: 168,
				border:"4px solid white"
			}} />
			
			<div style={{
				position:"absolute",
				left: 24,
				top: 180,
				width: 360 - 48
			}}>
				<p style={{
					color:"#BDBDBD",
					fontSize:16,
					textAlign:"center"
				}}> Yay! All Set! </p>
				<br/>
				<p style={{
					fontSize:24,
					lineHeight: 1.2,
				}}> The survey has completed! <br/> Thank you for taking part. </p>
				<p style={{
					fontSize:16,
				}}> Next, please answer a few questions about yourself and your use of Android.</p>

			</div>
		
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/AllSet.js